// extracted by mini-css-extract-plugin
module.exports = {"EnrollmentFormError":"FormError_EnrollmentFormError__9Mgjn","blockError":"FormError_blockError__VV2EQ"};